import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import UsuariosScreen from './Screen';
import { UsuariosAdapter, Usuario } from '../../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { useNotifications } from '../../../../../../shared/hooks/Notifications';

export const UsuariosContainer = () => {

	const api = new UsuariosAdapter();
	const {resultError, exceptionError, launchNotification}  = useNotifications();
	let [ usuarios, setUsuarios ] = useState<any>([]);
	let result: any;

	useEffect(() => {
		getUsuarios();
	}, []);

	useEffect(() => {}, [ usuarios ]);

	const getUsuarios = async () => {
		try {
			result = await api.ListarUsuarios();
			if(result.data && result.data!=="")
			{
				setUsuarios([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const createUsuario = async (usuario: any) => {
		try {
			const result:any = await api.CrearUsuario(usuario);
			if(result.data && result.data!=="")
			{
				setUsuarios([ ...usuarios,...result.data ] || []);
				launchNotification({type:"success",title:"Creación",message:"Se ha creado una nuevo usuario."})
			}else{
				resultError()
			}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
	};

	const deleteUsuario = async (usuario: Usuario) => {
		try {
			result = await api.EliminarUsuario(usuario.login);
			if(result.data && result.data!=="")
			{
				let pos = usuarios.findIndex((u: Usuario) => u.login === usuario.login);
				let newData = [ ...usuarios ];
				newData.splice(pos, 1);
				setUsuarios([ ...newData ] || []);
				launchNotification({type:"success",title:"Eliminación",message:"Se ha eliminado un usuario."})
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const updateUsuario = async (loginOLD:string,usuario: any) => {
		try {
			result = await api.ModificarUsuario(loginOLD,usuario);
			if(result.data && result.data!=="")
			{
				let pos = usuarios.findIndex((u: Usuario) => u.login === loginOLD);
				let newData = [ ...usuarios ];
				newData[pos] = result.data[0];
				setUsuarios([ ...newData ] || []);
				launchNotification({type:"success",title:"Modificación",message:"Se ha modificado un usuario."})
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

	const addCentrosUsuario = async (user:string,centros: string) => {
		try {
			const result:any = await api.AgregarCentrosUsuario(user,centros);
			if(result.data && result.data!=="")
			{
				let pos = usuarios.findIndex((u: Usuario) => u.login === user);
				let newData = [ ...usuarios ];
				newData[pos] = result.data[0];
				setUsuarios([ ...newData ] || []);
				launchNotification({type:"success",title:"Creación",message:"Se han agregado centros a un usuario."})
			}else{
				resultError()
			}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
	};

	return (
		<>
		<UsuariosScreen
			data={usuarios}
			handleCreate={createUsuario}
			handleRemove={deleteUsuario}
			handleUpdate={updateUsuario}
			handleAddCentros={addCentrosUsuario}
		/>
		</>
	);
};

export default UsuariosContainer;
